export default __webpack_public_path__ + "center-pad.697792.png";